export const initialState = {
    orders : [],
    loading : false,
    error: null,
    purchased: false
}
